module.exports = __webpack_public_path__ + "img/Group12462@2x.5b71d2c3.png";